import React from 'react';
import { Name, Ln, Git } from './styled';

const Social = ({ name }) => {
  return (
    <>
      <Name>{name}</Name>
      {/* <a href="https://github.com/milojevic1991?tab=repositories"> */}
      <a href="#">
        <Git />
      </a>

      {/* <a href="https://www.linkedin.com/in/nemanjamilojevic1991/"> */}
      <a href="#">
        <Ln />
      </a>
    </>
  );
};

export default Social;
